import { SupplierRelationshipListResponseType } from "@sellar-io/api-v2/types";

import {
  generateConnectionDiscountDescription,
  generateConnectionItemDiscountDescription,
} from "./BusinessConnectionConvertDiscountsCard.shared";

export type ItemType = {
  id: number;
  name: string;
  logo: string | null;
  description: string;
  priceTierName?: string;
};

export enum ConvertDiscountsPages {
  CHOOSE_BASE,
  ASSIGN,
}

export const getDiscountDescription = (
  connection: SupplierRelationshipListResponseType[number],
) => {
  return [
    ...connection.Discounts.map((discount) =>
      generateConnectionDiscountDescription(discount),
    ),
    ...connection.ProductItemDiscounts.map((discount) =>
      generateConnectionItemDiscountDescription(discount),
    ),
  ].join(" • ");
};
